// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RadioGroup_wrapper__2RFyN","item":"RadioGroup_item__1ABAy","selected":"RadioGroup_selected__1zzHS"};